import { ProgramThumbnailCard } from '@components/buzzkuri/shared/uiParts/card/ProgramThumbnailCard'
import { fetcher, useSWRImmutable } from '@libs/swr'
import {
  ProgramsSlugsPageRes,
  ProgramsCategoryPageContent,
} from '@type/buzzkuri/programs-categor'
// import { origin } from '@utils/http'
import { LightHeading } from '@components/buzzkuri/shared/uiParts/heading/LightHeading'

const endpointPath = '/api/programs/training'
// const endpoint = `${origin}${endpointPath}`

export const TrainingPrograms = (): JSX.Element => {
  const { data, error } = useSWRImmutable<ProgramsSlugsPageRes>(
    endpointPath,
    fetcher
  )
  if (error || !data) {
    return <></>
  } else {
    return (
      <div className="mt-[11.1vw] lg:mt-[4.7vw]">
        <div className="flex flex-col">
          <LightHeading text="Z世代向け関係構築/行動変容型研修プログラム" />

          <div className="flex flex-col lg:flex-row lg:justify-between items-center mt-[5.3vw] lg:mt-[1.6vw]">
            {(
              data.pageContent as ProgramsCategoryPageContent
            ).popularPrograms.map((item, i) => (
              <ProgramThumbnailCard
                key={i}
                id={item.id}
                imgSrc={item.imagePath}
                size="small"
              />
            ))}
          </div>
        </div>
      </div>
    )
  }
}
